import { Theme } from '@mui/material';

const supportedColors = (theme: Theme) => [
  theme.palette.green[200],
  theme.palette.blue[200],
  theme.palette.orange[200],
  theme.palette.violet[200],
  theme.palette.yellow[200],
];

const DJB2 = 5381;
function hashString(str: string): number {
  let hash = DJB2;
  for (let i = 0; i < str.length; i += 1) {
    // eslint-disable-next-line no-bitwise
    hash = (hash << 5) + hash + str.charCodeAt(i);
  }
  // eslint-disable-next-line no-bitwise
  return Math.abs(hash >>> 0);
}

export const getDeterministicColorFromName = (
  theme: Theme,
  name: string,
): string => {
  const palette = supportedColors(theme);
  const colorIndex = Math.abs(hashString(name)) % palette.length;
  const newColor = palette[colorIndex];
  return newColor;
};

export const getNameInitials = (name: string): string => {
  const nameParts = name
    .split(' ')
    .map((part: string) => part[0])
    .join('')
    .toUpperCase();

  return nameParts.substring(0, 2);
};
